// extracted by mini-css-extract-plugin
module.exports = {"dropdown_menu1":"MyClass_dropdown_menu1__2CSEc","Hr3":"MyClass_Hr3__COquK","menu1":"MyClass_menu1__2jaxB","menuList":"MyClass_menuList__3aoEk"};